/* eslint-disable func-names */
/* eslint-disable prefer-rest-params */
import { defineComponent, h, ref, onMounted, onUnmounted, watch, toRefs } from 'vue';
import Highcharts from 'highcharts';
// Load the exporting module.
import Exporting from 'highcharts/modules/exporting';
import BreakAxis from 'highcharts/modules/broken-axis';
import { breakAxisWrap } from './highcharts-wrap.js'

// Initialize exporting module.
Exporting(Highcharts);

const vueHighcharts = defineComponent({
  name: 'VueHighchart',
  props: {
    type: {
      type: String,
      default: 'chart'
    },

    options: {
      type: Object,
      required: true
    },

    redrawOnUpdate: {
      type: Boolean,
      default: true
    },

    oneToOneUpdate: {
      type: Boolean,
      default: false
    },

    animateOnUpdate: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: ''
    }
  },

  setup (props, { emit }) {
    const chartRef = ref(null);
    const chart = ref(null);

    const { options } = toRefs(props);
    /**
    * Extend the Axis.getLinePath method in order to visualize breaks with two parallel
    * slanted lines. For each break, the slanted lines are inserted into the line path.
    */
    Highcharts.setOptions({
      lang: {
        contextButtonTitle: 'Chart options'
      }
    });
    BreakAxis(Highcharts);
    breakAxisWrap(Highcharts);

    if (options.value && Highcharts[props.type]) {
      // this seems to block vite hot-update.
      // watch(options, (newValue, oldValue) => {
      //   console.log('option changed', chart, newValue, oldValue)
      //   if (chart.value) {
      //     chart.value.update(newValue, props.redrawOnUpdate, props.oneToOneOnUpdate, props.animateOnUpdate);
      //     while (chart.value.series.length) {
      //       chart.value.series[0].remove();
      //     }
      //     newValue.series.length && newValue.series.forEach(x => {
      //       chart.value.addSeries(x);
      //     });

      //     emit('updated');
      //   }
      // }, { deep: true });

      onMounted(() => {
        chart.value = Highcharts[props.type](chartRef.value, options.value);
        emit('rendered', chart.value);
        window.addEventListener('resize', resizeChart);
      });

      onUnmounted(() => {
        if (chart.value) chart.value.destroy();
        emit('destroyed');
        window.removeEventListener('resize', resizeChart);
      });
    } else if (!props.options) {
      console.warn('The "options" parameter is required.');
    } else {
      console.warn(`${props.type} is not a valid highcharts type or has not been imported`);
    }

    const resizeChart = () => {
      if (chart.value) {
        // console.log(chart.value.renderTo);
      }
    }
    // Rather than returning a render function here. We'll return the chart ref and highcharts
    // instance so there exposed.
    return {
      chartRef,
      chart,
      resizeChart
    };
  },

  render () {
    return h('div', {
      class: `vue-highcharts ${this.customClass}`,
      ref: 'chartRef'
    });
  }
});

export default vueHighcharts;
